// extracted by mini-css-extract-plugin
export default {"imageContainer":"styles_imageContainer__79iSQ","mainImageContainer":"styles_mainImageContainer__9FLQy"};